import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import BulletinHomeCard from './BulletinHomeCard';
import ManualHomeCard from './ManualHomeCard';

/**
 * 掲示板・マニュアル: 掲示板・社内マニュアル一覧の統合画面（6:4）
 * ワイド表示では各カラムが独立してスクロールする
 * 狭い画面ではタブで切り替え、パネル内でスクロールする
 */
const Dashboard: React.FC = () => {
  const theme = useTheme();
  const isNarrow = useMediaQuery(theme.breakpoints.down('md'));
  const [tab, setTab] = useState(0);

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        /* 狭い画面: タブ＋パネルで高さを埋め、ページ全体はスクロールしない。ワイドは従来どおりカラム内スクロール */
        overflow: { xs: 'hidden', md: 'hidden' },
      }}
    >
      <Typography variant="h5" component="h1" gutterBottom sx={{ mb: 2, flexShrink: 0 }}>
        掲示板・マニュアル
      </Typography>

      {isNarrow ? (
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            /* MainLayout の左右パディングを打ち消してタブ〜一覧を横幅いっぱいに */
            mx: { xs: -2, sm: -3 },
            width: { xs: 'calc(100% + 32px)', sm: 'calc(100% + 48px)' },
            maxWidth: { xs: 'calc(100% + 32px)', sm: 'calc(100% + 48px)' },
          }}
        >
          <Tabs
            value={tab}
            onChange={(_, v: number) => setTab(v)}
            variant="fullWidth"
            aria-label="掲示板・マニュアルの表示切り替え"
            sx={{
              flexShrink: 0,
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            <Tab label="掲示板" id="home-tab-bulletin" aria-controls="home-tabpanel-bulletin" />
            <Tab label="社内マニュアル" id="home-tab-manual" aria-controls="home-tabpanel-manual" />
          </Tabs>
          <Box
            role="tabpanel"
            id="home-tabpanel-bulletin"
            aria-labelledby="home-tab-bulletin"
            hidden={tab !== 0}
            sx={{
              flex: 1,
              minHeight: 0,
              display: tab === 0 ? 'flex' : 'none',
              flexDirection: 'column',
              overflow: 'hidden',
              pt: 1.5,
              px: { xs: 2, sm: 3 },
              pb: 0,
            }}
          >
            <BulletinHomeCard fillAvailableHeight />
          </Box>
          <Box
            role="tabpanel"
            id="home-tabpanel-manual"
            aria-labelledby="home-tab-manual"
            hidden={tab !== 1}
            sx={{
              flex: 1,
              minHeight: 0,
              display: tab === 1 ? 'flex' : 'none',
              flexDirection: 'column',
              overflow: 'hidden',
              pt: 1.5,
              px: { xs: 2, sm: 3 },
              pb: 0,
            }}
          >
            <ManualHomeCard fillAvailableHeight />
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            alignItems: 'stretch',
            overflow: { md: 'hidden' },
          }}
        >
          <Box
            sx={{
              flex: { xs: '1 1 auto', md: '6 1 0' },
              minWidth: 0,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              overflow: { md: 'hidden' },
            }}
          >
            <BulletinHomeCard />
          </Box>

          <Box
            sx={{
              flex: { xs: '1 1 auto', md: '4 1 0' },
              minWidth: 0,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              overflow: { md: 'hidden' },
            }}
          >
            <ManualHomeCard />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Dashboard;
